import { Instance, types } from "mobx-state-tree";

const BaseLaunchpadModel = types.model('BaseLaunchpadModel', {
    node_id: types.number, // Not a reference because we don't really use any field but the ID, for now
    center_id: types.number
})

export const NewLaunchpadModel = BaseLaunchpadModel.named('NewLaunchpadModel')
export const ExistingLaunchpadModel = BaseLaunchpadModel.named('ExistingLaunchpadModel')
    .props({
        id: types.identifierNumber,
        color: types.string,
        letter: types.string,
    })

export const LaunchpadModel = types.union(ExistingLaunchpadModel, NewLaunchpadModel)

export type Launchpad = Instance<typeof LaunchpadModel>